import { Coin } from "./ui/Coin.js";
import { SegControl } from "./ui/SegControl.js";

type Exchange =
  | "binance"
  | "bybit"
  | "okx"
  | "kraken"
  | "coinbase"
  | "kucoin"
  | "gateio"
  | "bitget";

type Timeframe = "1m" | "5m" | "15m" | "1h" | "4h" | "1d";

interface Props {
  symbol: string;
  exchange: Exchange;
  timeframe: Timeframe;
  onSymbol: (s: string) => void;
  onExchange: (e: Exchange) => void;
  onTimeframe: (t: Timeframe) => void;
}

const EXCHANGES: Exchange[] = [
  "binance",
  "bybit",
  "okx",
  "kraken",
  "coinbase",
  "kucoin",
  "gateio",
  "bitget",
];
const SYMBOLS = ["BTCUSDT", "ETHUSDT", "SOLUSDT", "BNBUSDT", "XRPUSDT"];
const TFS: Timeframe[] = ["1m", "5m", "15m", "1h", "4h", "1d"];

const selectStyle: React.CSSProperties = {
  padding: "6px 10px",
  background: "var(--surface-2)",
  border: "1px solid var(--border-soft)",
  borderRadius: 6,
  color: "var(--text)",
  fontSize: 12,
  outline: "none",
  fontFamily: "inherit",
};

function coinSym(symbol: string) {
  return symbol.replace(/USDT$|USD$|USDC$/, "");
}

export function SymbolSelector(props: Props) {
  const { symbol, exchange, timeframe, onSymbol, onExchange, onTimeframe } = props;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <Coin sym={coinSym(symbol)} size="sm" />
      <select
        value={exchange}
        onChange={(e) => onExchange(e.target.value as Exchange)}
        style={selectStyle}
      >
        {EXCHANGES.map((e) => (
          <option key={e} value={e}>
            {e}
          </option>
        ))}
      </select>
      <select
        value={symbol}
        onChange={(e) => onSymbol(e.target.value)}
        style={{ ...selectStyle, fontFamily: "var(--font-mono)" }}
      >
        {SYMBOLS.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>
      <SegControl<Timeframe>
        value={timeframe}
        options={TFS}
        onChange={onTimeframe}
      />
    </div>
  );
}
